export function textBlockValidator(data: {
  start: number;
  end: number;
}): boolean {
  return data.end > data.start;
}

export function textBlocksValidator(
  data: {
    start: number;
    end: number;
  }[]
): boolean {
  let line = [];

  for (let i = 0; i < data.length; i += 1) {
    line.push([data[i].start, 1]);
    line.push([data[i].end, -1]);
  }

  line = line.sort();

  for (let i = 0, cur = 0; i < line.length; i += 1) {
    cur += line[i][1];

    if (cur > 1) {
      return false;
    }
  }

  return true;
}

export function editorConfigValidator(editorConfig: string): boolean {
  if (!editorConfig || !editorConfig.length) {
    return false;
  }

  try {
    const json: object = JSON.parse(editorConfig);

    // @ts-ignore
    if (json?.timeline?.fitDuration < 1) {
      return false;
    }
  } catch {
    return false;
  }

  return true;
}

export const publicationURLsValidator = (data: {
  publication: number;
  publication_urls: string;
}): boolean =>
  !(
    data.publication >= 1 &&
    !data.publication_urls
      .split(',')
      .map((url) => url.trim())
      .filter((url) => url.length > 0).length
  );

export const rssSettingsFirstUpdateValidator = (data: {
  enabled: boolean;
  time?: string;
}): boolean =>
  !(data.enabled && (!('time' in data) || data.time === undefined));

export const rssSettingsPeriodValidator = (data: {
  enabled: boolean;
  interval_days?: number;
}): boolean =>
  !(
    data.enabled &&
    (!('interval_days' in data) || data.interval_days === undefined)
  );
